<script>
import BaseCard from "../Accommodatie/BaseCard";

export default {
  name: "AddRoleCard",
  extends: BaseCard,
  data: function() {
    return {
      header: "Rol toevoegen",
      disabled: false,
      showButton: false,
      values: {}
    };
  },
  computed: {
    schema: function() {
      return [
        {
          type: "text",
          name: "role_name",
          placeholder: "Naam",
          disabled: this.disabled,
          "input-class":
            "bg-gray-100 w-full h-10 px-5 pr-10 rounded-lg text-sm focus:outline-none border-gray-700 border font-opensans",
          validation: "required"
        },

        {
          type: "submit",
          "input-class": ["btn", "btn-blue", this.showButton ? "" : "disabled"],
          label: "Aanmaken"
        }
      ];
    }
  },
  watch: {
    values: function() {
      if (this.values["role_name"] != "") {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    }
  },
  methods: {
    submitHandler: function() {
      this.$store.dispatch("addRole", this.values["role_name"]);
    }
  }
};
</script>
